import React from 'react';

import { flagLinkPropTypes } from '../../utils';
import styles from './FlagLink.module.scss';

const FlagLink = ({ title, countryName, flag, url }) => {
	return (
		<li className={styles.flagLink}>
			<a href={url} target="_blank" rel="noreferrer">
				<div className={styles.flagWrapper}>
					<img src={flag} alt={`${countryName} flag`} />
				</div>
				{title}
			</a>
		</li>
	);
};

FlagLink.propTypes = flagLinkPropTypes;

export default FlagLink;
